"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chains = void 0;
const tslib_1 = require("tslib");
const TronDefinition = tslib_1.__importStar(require("./data/tron"));
const SolanaDefinition = tslib_1.__importStar(require("./data/solana"));
exports.chains = {
    tron: TronDefinition,
    solana: SolanaDefinition,
};
